<h1 class="page-title">Browse LookUps</h1>
<section class="widget">
    <div class="widget-body">
        <div class="mt">
            <div class="row">
                <div class="col-md-12">
                    <section class="widget lookup-form">
                        <form class="form-horizontal" [formGroup]="form" novalidate>
                            <div class="widget-body clearfix">
                                <div class="row flex-nowrap">
                                    <div class="col-md-6">
                                        <div class="row form-field-spacing"
                                             [class.has-danger]="category?.valid && category?.touched">
                                            <span class="col-md-3">Category</span>
                                            <div class="col-md-8">
                                              <select [formControl]="category" class="form-select"
                                                      type="text">
                                                  <option value="null">Choose a Category</option>
                                                  <option *ngFor="let item of categories" [value]="item.value">
                                                      {{splitCamelCase(item.key)}}
                                                  </option>
                                              </select>
                                                <div [hidden]="!(!category?.valid && category?.touched)"
                                                     class="validation-error">
                                                    This field is required
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="row form-field-spacing"
                                             [class.has-danger]="!sortOrder?.valid && sortOrder?.touched">
                                            <span class="col-md-3">Sort Order</span>
                                            <div class="col-md-8">
                                              <input [formControl]="sortOrder" class="form-control" type="text">
                                                <div [hidden]="!(!sortOrder?.valid && sortOrder?.touched)"
                                                     class="validation-error">
                                                    This field is required
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row flex-nowrap">
                                    <div class="col-md-6">
                                        <div class="row form-field-spacing"
                                             [class.has-danger]="!key?.valid && key?.touched">
                                            <span class="col-md-3">Key</span>
                                            <div class="col-md-8">
                                              <input [formControl]="key" class="form-control" type="text">
                                                <div [hidden]="!(!key?.valid && key?.touched)"
                                                     class="validation-error">
                                                    This field is required
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="row form-field-spacing"
                                             [class.has-danger]="!lookupValue?.valid && lookupValue?.touched">
                                            <span class="col-md-3">Value</span>
                                            <div class="col-md-8">
                                              <input [formControl]="lookupValue" class="form-control"
                                                     type="text">
                                                <div [hidden]="!(!lookupValue?.valid && lookupValue?.touched)"
                                                     class="validation-error">
                                                    This field is required
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row flex-nowrap">
                                    <div class="col-md-6">
                                        <div class="row form-field-spacing">
                                            <span class="col-md-3">Description</span>
                                            <div class="col-md-8">
                                              <textarea [formControl]="description" class="form-control"
                                                        type="text">
                                              </textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="display-flex flex-row align-items-center w-100">
                                    <button class="btn btn-outline-primary me-2" type="button" name="button"
                                            (click)="clearSelectedLookUp()">Add New Entry
                                    </button>
                                    <button class="btn btn-primary me-2" type="button" name="button"
                                            (click)="submit()">Save
                                    </button>
                                    <button class="btn btn-danger ms-auto" [disabled]="!currentLookUp" type="button"
                                            name="button" (click)="delete()">Delete Look Up Entry
                                    </button>
                                </div>
                            </div>
                        </form>
                    </section>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="row mb-2">
                        <label class="col-2">Category:</label>
                        <dropdown class="drop-down-inline"
                                  [promptValue]="'Categories'"
                                  [values]="lookUpCategoryDropdown"
                                  (select)="selectedCategory($event)"></dropdown>
                    </div>
                </div>
                <div class="col-md"></div>
            </div>
            <table-dynamic id="datatable-table"
                           class="table table-striped table-hover"
                           [headers]="tableHeaders"
                           [currentPage]="currentPage"
                           [totalCount]="totalCount"
                           (headerClick)="sortItems($event)"
                           (pageChanged)="setPage($event)"
                           (limitChange)="setLimit($event)">
                <tr *ngFor="let lookUp of pagedList?.items"
                    [ngClass]="{selected: lookUp == currentLookUp}"
                    (click)="setCurrentSelectedLookUp(lookUp)" class="cursor-pointer">
                    <td class="hidden-sm-down">{{formatCategory(lookUp.category)}}</td>
                    <td>
                        <a><span class="hidden-sm-down">{{lookUp.key}}</span></a>
                    </td>
                    <td>{{lookUp.lookupValue}}</td>
                    <td class="hidden-sm-down">{{lookUp.description}}</td>
                    <td class="hidden-sm-down">{{lookUp.sortOrder}}</td>
                </tr>
            </table-dynamic>
        </div>
    </div>
</section>
